import React, { useEffect, useState } from "react";
import { pubCall } from "../../utils/PubSub";
import { showError } from "../../ui/Message";
import VirtualTable from "../../ui/VirtualTable";
import { moveItem } from "../../utils/Utils";

export default function ISBNSearch(props) {

    const { controller = "", search = "", route = "" } = props;

    const [selected, setSelected] = useState({});
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [align, setAlign] = useState("auto");
    const row_key = "stock_id";

    useEffect(() => {

        pubCall("stock.searchIsbnStartingWith", { isbn: search }, (_s, _r) => {
            if (_s) {
                setResults(_r);
            } else {
                showError(_r);
            }
        })

    }, [])

    //  O/H  Title  Price  ISBN 
    const columns = [
        { min: true, width: 50, key: "total_onhand", align: "right", title: <>O/H</> },
        { min: true, width: 150, grow: true, align: "left", key: "title", title: <>Title</> },
        { min: true, width: 50, key: "price", align: "right", title: <>Price</> },
        { min: true, width: 50, key: "primary_code", align: "left", title: <>ISBN</> },
    ];


    const move = (rows = 1) =>{
        moveItem({data : results, selected, setSelected, row_key, step: rows, setAlign, alignOnMove: true});
    }
        



    return (<>
        <div className="shim" /><div className="shim" />
        <VirtualTable
            row_height={26}
            controller={controller}
            onRowDoubleClick={() => {

            }}
            onRowClick={(item, event, index) => {
                setSelected(item)
            }}
            next={(e) => move((e) ? e : 1)}
            prev={(e) => move((e) ? e*-1 : -1)}
            align={"auto"}
            row_key={row_key}
            current={selected}
            data={results}
            height={251}
            columns={columns}
            width={600}
            loading={loading}
            offset={430}
            route={route}

        />
    </>)
}